<template>
  <!-- <shipping-label-modal :show-modal="showModal" editType="receiveShipping" :hideNext="true" v-loading="loading" :shippingId="dispatch.id"
    @close-modal="$emit('close-modal')" :dispatch="dipsatch" :action="action"> -->
    <el-dialog :visible.sync="showModal" title="" width="55%">
      <div class=" modals-wrapper ">
        <div class="flex items-center gap-2 pb-4 px-2 rounded-md mb-5" :style="{ 'background-color': '#FBFCFE'}">
          <span class="">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.00014 0.320312C3.75774 0.320312 0.319336 3.75871 0.319336 8.00031C0.319231 9.009 0.517829 10.0078 0.903788 10.9398C1.28975 11.8717 1.85551 12.7184 2.56876 13.4317C3.282 14.1449 4.12877 14.7107 5.0607 15.0967C5.99262 15.4826 6.99145 15.6812 8.00014 15.6811C12.2409 15.6811 15.6801 12.2427 15.6801 8.00031C15.6801 3.75871 12.2409 0.320312 8.00014 0.320312ZM8.71694 3.09311C9.46574 3.09311 9.68574 3.52751 9.68574 4.02431C9.68574 4.64431 9.18974 5.21791 8.34254 5.21791C7.63374 5.21791 7.29614 4.86191 7.31694 4.27231C7.31694 3.77551 7.73214 3.09311 8.71694 3.09311ZM6.79854 12.6003C6.28654 12.6003 5.91294 12.2891 6.27054 10.9251L6.85694 8.50511C6.95854 8.11791 6.97534 7.96271 6.85694 7.96271C6.70414 7.96271 6.03934 8.22991 5.64734 8.49391L5.39214 8.07551C6.63614 7.03631 8.06653 6.42671 8.67853 6.42671C9.19053 6.42671 9.27534 7.03151 9.02013 7.96271L8.34814 10.5067C8.22894 10.9563 8.28014 11.1115 8.39933 11.1115C8.55293 11.1115 9.05534 10.9259 9.54974 10.5363L9.83934 10.9251C8.62893 12.1347 7.30974 12.6003 6.79854 12.6003Z"
                fill="#C2C7D6" />
            </svg>
          </span>
          <p class="pt-3">
            Alex Iwu from IFEX Logistics have initiated a delivery action for the shipment below. Kindly confirm receipt.
          Your receipt code is 1012312
          </p>
          
        </div>
      </div>
      <div v-if="Object.keys(dispatch).length > 0" id="printable">
        <div class="flex items-center justify-between mb-4">
          <div class="flex gap-5">
            <div class="flex flex-col justify-end px-3" id="mulex" style="border-right: 1px solid">
              <p class="font-bold text-5xl text-black">MuleEx</p>
              <span id="ref"
                >#{{
                  dispatch.dispatchReference ? dispatch.dispatchReference : "----"
                }}</span
              >
            </div>
            <qrcode style="width: 76px; height: 72px" />
          </div>
          <div class="flex gap-4" v-if="!action">
            <span class="cursor-pointer" @click="$emit('close-modal')"
              >Close</span
            >
            <span class="cursor-pointer" @click="printElement">Print</span>
            <span class="cursor-pointer">Share</span>
          </div>
          <div class="flex flex-col">
            <span id="standard">STANDARD SHIPPING</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div style="border: 1px solid #09b78a" class="h-72 min-h-72">
              <div
                class="flex relative h-16 gap-4 items-center"
                style="background: #09b78a1a"
              >
                <svg
                  style="position: absolute; top: 0"
                  width="64"
                  height="68"
                  viewBox="0 0 64 68"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H64V60.4444L30.5672 68L0 60.4444V0Z"
                    fill="#09B78A"
                  />
                  <path
                    d="M40.4375 27.1875C40.4375 24.9497 39.5486 22.8036 37.9662 21.2213C36.3839 19.6389 34.2378 18.75 32 18.75C29.7622 18.75 27.6161 19.6389 26.0338 21.2213C24.4514 22.8036 23.5625 24.9497 23.5625 27.1875C23.5625 30.6488 26.3319 35.16 32 40.5637C37.6681 35.16 40.4375 30.6488 40.4375 27.1875ZM32 43.125C25.1244 36.8756 21.6875 31.5619 21.6875 27.1875C21.6875 24.4525 22.774 21.8294 24.708 19.8955C26.6419 17.9615 29.265 16.875 32 16.875C34.735 16.875 37.3581 17.9615 39.292 19.8955C41.226 21.8294 42.3125 24.4525 42.3125 27.1875C42.3125 31.5619 38.8756 36.8756 32 43.125Z"
                    fill="white"
                  />
                  <path
                    d="M32 28.125C32.4973 28.125 32.9742 27.9275 33.3258 27.5758C33.6775 27.2242 33.875 26.7473 33.875 26.25C33.875 25.7527 33.6775 25.2758 33.3258 24.9242C32.9742 24.5725 32.4973 24.375 32 24.375C31.5027 24.375 31.0258 24.5725 30.6742 24.9242C30.3225 25.2758 30.125 25.7527 30.125 26.25C30.125 26.7473 30.3225 27.2242 30.6742 27.5758C31.0258 27.9275 31.5027 28.125 32 28.125ZM32 30C31.0054 30 30.0516 29.6049 29.3483 28.9017C28.6451 28.1984 28.25 27.2446 28.25 26.25C28.25 25.2554 28.6451 24.3016 29.3483 23.5983C30.0516 22.8951 31.0054 22.5 32 22.5C32.9946 22.5 33.9484 22.8951 34.6516 23.5983C35.3549 24.3016 35.75 25.2554 35.75 26.25C35.75 27.2446 35.3549 28.1984 34.6516 28.9017C33.9484 29.6049 32.9946 30 32 30ZM42.125 35.625L45.125 43.125H36.6875V41.25H27.3125V43.125H18.875L21.875 35.625H42.125ZM40.1056 35.625H23.8944L21.6444 41.25H42.3556L40.1056 35.625Z"
                    fill="white"
                  />
                </svg>
                <span style="margin-left: 5rem">Pickup From: </span>
              </div>
              <div class="p-4">
                <address>
                  {{
                    dispatch.shipperlocation
                      ? formatAddress(dispatch.shipperlocation.address) + ","
                      : "7b Montgomery Drive Friend’s Coloney Estate Lekki, Lagos State Nigeria"
                  }}
                  <br />
                  {{
                    dispatch.shipperlocation
                      ? dispatch.shipperlocation.city + ","
                      : "Lagos"
                  }}
                  <br />
                  {{
                    dispatch.shipperlocation
                      ? dispatch.shipperlocation.country
                      : "Nigeria"
                  }}
                </address>
                <hr />
                <p class="mt-3 font-semibold">
                  {{
                    dispatch.shipperlocation
                      ? dispatch.shipperlocation.contactName
                      : "Regina Smith"
                  }}
                  <span class="text-red">{{
                    dispatch.shipperlocation
                      ? dispatch.shipperlocation.mobile
                      : "N/A"
                  }}</span>
                </p>
              </div>
              <div class="py-2 px-4" style="border-top: 1px solid #09b78a">
                <span>
                  {{
                    dispatch.sourcePickupTime
                      ? formatDate(
                          dispatch.sourcePickupTime
                            ? dispatch.sourcePickupTime
                            : "N/A"
                        )
                      : "Date not available"
                  }}
                </span>
              </div>
            </div>
          </div>
  
          <div class="col-md-6">
            <div style="border: 1px solid #fcc210" class="h-72 min-h-72">
              <div
                class="flex relative h-16 gap-4 items-center"
                style="background: #fcc2101a"
              >
                <svg
                  style="position: absolute; top: 0"
                  width="64"
                  height="68"
                  viewBox="0 0 64 68"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H64V60.4444L30.5672 68L0 60.4444V0Z"
                    fill="#FCC210"
                  />
                  <path
                    d="M40.4375 27.1875C40.4375 24.9497 39.5486 22.8036 37.9662 21.2213C36.3839 19.6389 34.2378 18.75 32 18.75C29.7622 18.75 27.6161 19.6389 26.0338 21.2213C24.4514 22.8036 23.5625 24.9497 23.5625 27.1875C23.5625 30.6488 26.3319 35.16 32 40.5637C37.6681 35.16 40.4375 30.6488 40.4375 27.1875ZM32 43.125C25.1244 36.8756 21.6875 31.5619 21.6875 27.1875C21.6875 24.4525 22.774 21.8294 24.708 19.8955C26.6419 17.9615 29.265 16.875 32 16.875C34.735 16.875 37.3581 17.9615 39.292 19.8955C41.226 21.8294 42.3125 24.4525 42.3125 27.1875C42.3125 31.5619 38.8756 36.8756 32 43.125Z"
                    fill="white"
                  />
                  <path
                    d="M32 28.125C32.4973 28.125 32.9742 27.9275 33.3258 27.5758C33.6775 27.2242 33.875 26.7473 33.875 26.25C33.875 25.7527 33.6775 25.2758 33.3258 24.9242C32.9742 24.5725 32.4973 24.375 32 24.375C31.5027 24.375 31.0258 24.5725 30.6742 24.9242C30.3225 25.2758 30.125 25.7527 30.125 26.25C30.125 26.7473 30.3225 27.2242 30.6742 27.5758C31.0258 27.9275 31.5027 28.125 32 28.125ZM32 30C31.0054 30 30.0516 29.6049 29.3483 28.9017C28.6451 28.1984 28.25 27.2446 28.25 26.25C28.25 25.2554 28.6451 24.3016 29.3483 23.5983C30.0516 22.8951 31.0054 22.5 32 22.5C32.9946 22.5 33.9484 22.8951 34.6516 23.5983C35.3549 24.3016 35.75 25.2554 35.75 26.25C35.75 27.2446 35.3549 28.1984 34.6516 28.9017C33.9484 29.6049 32.9946 30 32 30ZM42.125 35.625L45.125 43.125H36.6875V41.25H27.3125V43.125H18.875L21.875 35.625H42.125ZM40.1056 35.625H23.8944L21.6444 41.25H42.3556L40.1056 35.625Z"
                    fill="white"
                  />
                </svg>
                <span style="margin-left: 5rem">Deliver To: </span>
              </div>
              <div class="p-4">
                <address>
                  {{
                    dispatch.consigneelocation
                      ? formatAddress(dispatch.consigneelocation.address) + ","
                      : "7b Montgomery Drive Friend’s Coloney Estate Lekki, Lagos State Nigeria"
                  }}
                  <br />
                  {{
                    dispatch.consigneelocation
                      ? dispatch.consigneelocation.city + ","
                      : "Lagos"
                  }}
                  <br />
                  {{
                    dispatch.consigneelocation
                      ? dispatch.consigneelocation.country
                      : "Nigeria"
                  }}
                </address>
                <hr />
                <p class="mt-3 font-semibold">
                  {{
                    dispatch.consigneelocation
                      ? dispatch.consigneelocation.contactName
                      : "Kay Teller"
                  }}
                  <span class="text-red">{{
                    dispatch.consigneelocation
                      ? dispatch.consigneelocation.mobile
                      : "09034758987"
                  }}</span>
                </p>
              </div>
              <div class="py-2 px-4" style="border-top: 1px solid #fcc210">
                <span>
                  {{
                    dispatch.destinationPickupTime
                      ? formatDate(
                          dispatch.destinationPickupTime
                            ? dispatch.destinationPickupTime
                            : "N/A"
                        )
                      : "Date not available"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-4 p-2" style="background: #f9fafc">
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="flex flex-col gap-1">
              <span class="font-semibold">ORDER CHANNEL</span><span>MuleEx</span>
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="flex flex-col gap-1">
              <span class="font-semibold">ORDER #</span
              ><span>#{{ dispatch.dispatchReference }}</span>
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="flex flex-col gap-1">
              <span class="font-semibold">INSURED VALUE</span
              ><span
                >N{{
                  dispatch.transaction
                    ? dispatch.transaction.breakDown != undefined
                      ? JSON.parse(dispatch.transaction.breakDown).insuranceFee
                      : "0.00"
                    : "0.00"
                }}</span
              >
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="flex flex-col gap-1">
              <span class="font-semibold">SHIPPING COST</span
              ><span
                >N{{
                  dispatch.transaction ? dispatch.transaction.totalValue : "0.00"
                }}</span
              >
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="flex flex-col gap-1">
              <span class="font-semibold">PAYMENT STATUS</span>
              <span class="flex gap-2">
                {{ dispatch.paymentStatus }}
              </span>
            </p>
          </div>
        </div>
        <!-- <h3 class="font-semibold text-base">Order Items</h3>
        <table class="custom-table responsive-table border-collapse">
          <thead>
            <tr class="shadow-md rounded-lg">
              <th>Item</th>
              <th>Quantity</th>
              <th>Dimension (Cm)</th>
              <th>Gross Weight(kg)</th>
              <th>Total Cost(N)</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="pack in dispatch.packagees"
              :key="pack.id"
              class="shadow-md rounded-lg"
            >
              <td>{{ pack.description }}</td>
              <td>{{ pack.quantity }}</td>
              <td>{{ pack.length ? pack.length : "N/A" }}</td>
              <td>{{ pack.estimatedWeight }}</td>
              <td>{{ pack.itemValue }}</td>
            </tr>
          </tbody>
        </table> -->
      </div>
      <div v-if="action" class="flex justify-between items-center pt-4">
        <span class="cursor-pointer" @click="closeModal">cancel</span>
        <base-button
          v-if="dispatch.id && !hideNext"
          text=" Next"
          @click="action"
        />
        <base-button
          v-if="dispatch.id && editType === 'receiveShipping'"
          text=" Confirm Receipt"
          @click="action"
        />
      </div>
  </el-dialog>
    
  <!-- </shipping-label-modal> -->
</template>

<script>
// import ShippingLabelModal from "@/components/3pl/Operations/Bookings/Modals/ShippingLabelModal";
export default {
  components: {
    // ShippingLabelModal,
  },
  props: {
    dispatch: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      showDetails: false,
    };
  },

  methods: {
    action() {
      this.updateStatus()
    },

    async updateStatus(){
			let request = {
				dispatchStatus : 'received',
				message : "Status Updated to " + 'received',
				userId : this.$store.state.authentication.quantumUserId
			}

			try{
				this.loading = true

				await this.$_modifyDispatch(this.dispatch.id, request)

				this.loading = false 
				this.$emit('refetch-dispatch')
				this.$emit('close-modal')
			}catch(error){
				this.loading = false;
				this.handleError(error);
			}
			
		},
    
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}

p {
  text-align: left;
}
</style>
